import React from "react"
import { VStack, Text } from "@chakra-ui/react"
import { Dialog as ChakraDialog } from "@chakra-ui/react"
import { CancelButton, ConfirmButton } from "@hydrologiq/shared/content/components/Button"

export interface MonitoringFeatureConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  featureName: string
  loading?: boolean
}

const MonitoringFeatureConfirmationDialog: React.FC<MonitoringFeatureConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  featureName,
  loading = false,
}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <ChakraDialog.Root open={open} onOpenChange={(details) => !details.open && onClose()}>
      <ChakraDialog.Backdrop />
      <ChakraDialog.Positioner>
        <ChakraDialog.Content maxWidth="md">
          <ChakraDialog.Header>
            <ChakraDialog.Title>Disable weight calculation?</ChakraDialog.Title>
            <ChakraDialog.CloseTrigger onClick={onClose} />
          </ChakraDialog.Header>

          <ChakraDialog.Body>
            <VStack gap={3} align="stretch">
              <Text>
                Are you sure you want to{" "}
                <Text as="span" fontWeight="bold">
                  disable weight calculation
                </Text>
                ? This will disable any fuel level monitoring and forecasting.
              </Text>
              <Text fontSize="sm" color="gray.600">
                Note: Volume information is required for weight calculation. Ensure your asset has valid volume data
                before re-enabling this feature.
              </Text>
            </VStack>
          </ChakraDialog.Body>

          <ChakraDialog.Footer gap={3}>
            <CancelButton onClick={onClose} disabled={loading} />
            <ConfirmButton onClick={handleConfirm} disabled={loading} loading={loading} colorPalette="red">
              Disable Feature
            </ConfirmButton>
          </ChakraDialog.Footer>
        </ChakraDialog.Content>
      </ChakraDialog.Positioner>
    </ChakraDialog.Root>
  )
}

export default MonitoringFeatureConfirmationDialog
